import '@Partials/_ComStyles.scss';
import '@Partials/_SimpleStyles.scss';
import './BorderRedButtonV2.scss';

export default function BorderRedButtonV2(props){

    const className = 'button__borderRedButtonV2';

    return (
        <button onClick={props.onClick} className={className + (props.disabled ? '__disabled' : '') + ' width-wfa'} disabled={props.disabled}>
            {props.text}
        </button>
    );
}
